import type { PremiumQuotaStatus } from '../../premium';
import experiment from 'experiment';

export const getTranslationKey = (
  premiumQuotaStatus: PremiumQuotaStatus,
  isMaxPremium: boolean,
) => {
  const gracePeriodOpen = experiment.isOpen(
    'specs.wixCode.CMSWebUsageLimitsGracePeriod',
  );

  const { itemsQuotaStatus } = premiumQuotaStatus;

  if (itemsQuotaStatus === 'EXCEEDED') {
    if (isMaxPremium) {
      return 'CONTENT_MANAGER_6_BUTTON_MANAGE_CONTENT_ITEMS_LIMIT_EXCEEDED_MAX_PLAN';
    }
    if (gracePeriodOpen) {
      return 'CONTENT_MANAGER_6_BUTTON_MANAGE_CONTENT_ITEMS_LIMITS_GRACE_PERIOD';
    }
    return 'CONTENT_MANAGER_6_BUTTON_MANAGE_CONTENT_ITEMS_LIMIT_EXCEEDED_V2';
  }

  if (itemsQuotaStatus === 'APPROACHING') {
    return 'CONTENT_MANAGER_6_BUTTON_MANAGE_CONTENT_ITEMS_LIMIT_APPROACHING';
  }
};
